import MainHeading from "../../../components/comman/MainHeading";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import CommonTable from "../../../components/comman/CommonTable";
import FilterComponent from "../../../components/comman/FilterComponent";
import ViewIcon from "../../../components/Icons/ViewIcon";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  updateDateFilter,
  updateFiltersStates,
} from "../../../store/actions/UserActions";
import DownloadIcon from "../../../components/Icons/DownloadIcon";
import BankIcon from "../../../components/Icons/BankIcon";
import ExportDataHandler from "../../../utility/ExportDataHandler";

export default function PaySlip() {
  const navigate = useNavigate();
  const timeoutId = useRef(null);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const dateFilter = useSelector((state) => state.root.months);
  const dispatch = useDispatch();
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    searchQuery: "",
    companyList: [],
    sitesList: [],
    isLoadingGeneratePayslip: false,
    cardCounts: {
      totalSalaryCreated: 0,
      totalAttendanceLocked: 0,
    },
  });

  useEffect(() => {
    GetCompanyList();
  }, []);

  useEffect(() => {
    GetPaySlip();
  }, [dateFilter, pageStates?.searchQuery, filterDetails?.companyId]);

  const GetPaySlip = () => {
    let options = {
      method: "GET",
    };
    const filterData = {
      months: dateFilter,
      searchQuery: pageStates?.searchQuery,
      companyId: filterDetails?.companyId,
    };
    const Url =
      apiUrl.get_sites_for_team_payslip + "?" + MainFilterHandler(filterData);
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.map((item) => ({
          ...item,
          salaryStatus:
            item?.isSalaryCreated === true ? (
              <span className="badge  bg-green-25 fw-normal rounded-pill">
                Yes
              </span>
            ) : (
              <span className="badge bg-red-25 fw-normal rounded-pill">No</span>
            ),
          AttendanceLockStatus:
            item?.isAttendnaceLocked === true ? (
              <span className="badge  bg-green-25 fw-normal rounded-pill">
                Yes
              </span>
            ) : (
              <span className="badge bg-red-25 fw-normal rounded-pill">No</span>
            ),
        }));
        const totalSalaryCreated = res?.data?.filter(
          (item) => item?.isSalaryCreated === true
        ).length;

        const totalAttendanceLocked = res?.data?.filter(
          (item) => item?.isAttendnaceLocked === true
        ).length;

        setPageStates((pre) => ({
          ...pre,
          sitesList: newData,
          cardCounts: {
            totalSalaryCreated,
            totalAttendanceLocked,
          },
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 500);
  };

  const sortHandler = (data, type = null) => {
    dispatch(
      updateFiltersStates({
        ...(type == "companyId" && {
          companyId: data?.companyId,
          siteId: "",
        }),
      })
    );
  };

  const sortList = {
    companyList: pageStates?.companyList,
    isShow: true,
  };

  const GetCompanyList = (inputValue = null) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };

      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));

      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const singleDateChangeHandler = (date) => {
    if (!date || !moment(date).isValid()) return;

    const selectedStartDate = moment(date)
      .startOf("month")
      .format("YYYY-MM-DD");
    const selectedEndDate = moment(date).endOf("month").format("YYYY-MM-DD");
    dispatch(updateDateFilter([selectedStartDate, selectedEndDate]));
  };

  const HandleView = (data) => {
    navigate(`${RoutesLink?.payslip_site_wise}/${data?.id}`, {
      state: { data: { name: data?.name }, month: dateFilter },
    });
  };

  const TableHeading = [
    { value: "name", label: "Site Name" },
    { value: "AttendanceLockStatus", label: "Attendance Lock Status" },
    { value: "salaryStatus", label: "Salary Status" },
  ];

  const handleExportBankData = (data) => {
    if (!data?.isSalaryCreated) {
      toast.error("Salary has not been created yet.");
      return;
    }
    let exportData = {
      exportDataType: "bankPayoutData",
      siteId: data?.id,
      months: dateFilter,
      searchQuery: pageStates?.searchQuery,
      companyId: filterDetails?.companyId,
    };
    ExportDataHandler(exportData, true);
  };

  const handleExportSalaryData = (data) => {
    if (!data?.isSalaryCreated) {
      toast.error("Salary has not been created yet.");
      return;
    }
    let exportData = {
      exportDataType: "salaryData",
      siteId: data?.id,
      months: dateFilter,
      searchQuery: pageStates?.searchQuery,
      companyId: filterDetails?.companyId,
    };
    ExportDataHandler(exportData, true);
  };

  const ActionData = [
    {
      label: "Bank Data",
      className: "btn btn-link",
      icon: <BankIcon />,
      title: "Download Bank Data",
      clickHandler: handleExportBankData,
    },
    {
      label: "Salary Data",
      className: "btn btn-link",
      icon: <DownloadIcon />,
      title: "Download Salary Data",
      clickHandler: handleExportSalaryData,
    },
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view site users",
      clickHandler: HandleView,
    },
  ];

  return (
    <>
      {pageStates?.isLoadingGeneratePayslip && <BgBlurLoader />}
      <div className="content">
        <MainHeading
          title={"Pay Slip"}
          showDefaultDate={true}
          singleDateChangeHandler={singleDateChangeHandler}
          pickerType="month"
        />

        <div className="row mb-4">
          {[
            {
              title: "Total Salary Created",
              value: pageStates?.cardCounts?.totalSalaryCreated || 0,
              color: "text-success",
            },
            {
              title: "Total Attendance Locked",
              value: pageStates?.cardCounts?.totalAttendanceLocked || 0,
              color: "text-primary",
            },
          ].map((card, index) => (
            <div key={index} className="col-md-6 col-sm-6 mb-3">
              <div className="card shadow h-100">
                <div className="card-body text-center">
                  <h4 className="text-muted">{card.title}</h4>
                  <h3 className={`fw-bold ${card.color}`}>{card.value}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="card mb-4">
          <div className="card-body">
            <FilterComponent
              handleSearch={handleSearchChange}
              searchPlaceHolder={"Search by site Name"}
              filterArray={sortList}
              sortHandler={sortHandler}
              handleData={sortHandler}
              pageStates={pageStates}
              getCompany={GetCompanyList}
            />
            <CommonTable
              TableHeading={TableHeading}
              TableData={pageStates?.sitesList}
              ActionData={ActionData}
              isLoading={pageStates?.tableLoader}
            />
          </div>
        </div>
      </div>
    </>
  );
}
